//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Swiper from 'swiper';

export default {
  name: 'thumbnail-gallery-swiper',
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
    PlayerVideo: () => import('@motionelements/catalog/src/modules/product/preview/players/PlayerGalleryItemVideo.vue'),
  },
  props: {
    element: Object,
    items: Array,
    topSwiperOptions: {
      type: Object,
    },
    thumbSwiperOptions: {
      type: Object,
    },
    arrowsPadding: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultTopSwiperOptions: {
        spaceBetween: 10,
        preloadImages: false,
        lazy: false,
        autoHeight: true,
        simulateTouch: false,
        thumbs: {
          swiper: this.thumbSwiper,
        },
      },
      defaultThumbsSwiperOptions: {
        spaceBetween: 10,
        slidesPerView: 3,
        slidesPerGroup: 1,
        threshold: 10,
        autoplay: {
          delay: 5000,
        },
        breakpoints: {
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 4,
          },
        },
      },
      topSwiper: {
        activeIndex: 0, // keep this for vue component css match
      },
      thumbSwiper: {},
    };
  },
  computed: {
    hasVideo() {
      return _.get(this.element, 'previews.mp4.url');
    },
    mergedTopSwiperOptions() {
      return { ...this.defaultTopSwiperOptions, ...this.topSwiperOptions };
    },
    mergedThumbSwiperOptions() {
      return { ...this.defaultThumbsSwiperOptions, ...this.thumbSwiperOptions };
    },
    disablePrev() {
      return this.topSwiper.isBeginning && !this.mergedThumbSwiperOptions.loop;
    },
    disableNext() {
      // return false;
      // return this.isEnd && !this.mergedThumbSwiperOptions.loop;
      return this.topSwiper.isEnd && !this.mergedThumbSwiperOptions.loop;
    },
    // activeIndex() {
    //   return this.topSwiper.activeIndex;
    // },
    previews() {
      return _.get(this.element, 'previews.jpgs', []).map(({ url }) => url);
    },
  },
  mounted() {
    console.log('Current Gallery Swiper instance object', this.topSwiper, this.thumbSwiper);
  },
  methods: {
    onLoad() {
      this.initSwipers();
    },
    initSwipers() {
      console.log('init thumb swiper');
      this.thumbSwiper = new Swiper(this.$refs.thumbSwiper, {
        ...this.mergedThumbSwiperOptions,
      });
      console.log('init top swiper');
      this.topSwiper = new Swiper(this.$refs.topSwiper, {
        ...this.mergedTopSwiperOptions,
      });
    },
    getLargePreview(thumbUrl) {
      const fileName = thumbUrl.split('/').pop().split('.')[0];
      if (fileName) {
        const previewUrl = this.previews.find((url) => url.indexOf(fileName) > -1);
        if (previewUrl) return previewUrl;
      }
      return thumbUrl;
    },
    slideNext() {
      this.topSwiper.slideNext();
      this.thumbSwiper.slideNext();
    },
    slidePrev() {
      this.topSwiper.slidePrev();
      this.thumbSwiper.slidePrev();
    },
    handleClickThumb(thumbIndex) {
      // console.log(this.thumbSwiper.clickedIndex);
      this.topSwiper.slideTo(this.thumbSwiper.clickedIndex);
      this.thumbSwiper.slideTo(this.thumbSwiper.clickedIndex);
      // video control
      if (this.hasVideo) {
        if (thumbIndex === 0) {
          this.$videoPlayer.play();
        } else {
          this.$videoPlayer.pause();
        }
      }
    },
  },
};
